import { selectTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const CURRICULUM_THEME: BuildingBlockNodeConfig = {
  nodeSelector: selectTitleNode,
  information: {
    single: 'Leerplanthema',
    plural: "Leerplanthema's",
  },

  buildingBlocks: [{ type: NodeType.CURRICULUM_THEME }, { type: NodeType.THEME }],
  edit: [titleComponent],
  onNewNodeDropped: {
    focusOnField: 'title',
  },
  confirmDelete: true,
  isCollapsible: false,
};

export default CURRICULUM_THEME;
